const AdditionalInformation = () =>
  import(
    /* webpackChunkName: "AdditionalInformation" */ "@/components/ssp/missions/mission/mission-intervention/AdditionalInformation.vue"
  );
const SurveysList = () =>
  import(
    /* webpackChunkName: "SurveysAndSamples" */ "@/components/ssp/missions/mission/mission-intervention/SurveysList.vue"
  );

const OrdersTracking = () =>
  import(
    /* webpackChunkName: "SurveysAndSamples" */ "@/components/ssp/missions/mission/mission-intervention/OrdersTracking.vue"
  );

const AnalyticProgramSynthesis = () =>
  import(
    /* webpackChunkName: "AnalyticProgramSynthesis" */ "@/components/ssp/missions/mission/mission-intervention/AnalyticProgramSynthesis.vue"
  );

import getPreparationAndMaterials from "@/router/middleware/getPreparationAndMaterials";

export default [
  {
    path: "",
    name: "SurveysAndSamples",
    component: SurveysList,
    beforeEnter: getPreparationAndMaterials,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "program-analytic-synthesis",
    name: "AnalyticProgramSynthesis",
    component: AnalyticProgramSynthesis,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "orders-tracking",
    name: "OrdersTracking",
    component: OrdersTracking,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "additional-information",
    name: "AdditionalInformation",
    component: AdditionalInformation,
    meta: {
      showSubNavBar: true,
    },
  },
];
